module.exports = __webpack_public_path__ + "static/media/A1.6afd6cb7.jpg";